module.exports = __webpack_public_path__ + "img/5.900db4f3.jpg";